import { Injectable } from '@angular/core';
import { FormArray } from '@angular/forms';
import { QuestionItemV2 } from '@examdojo/models/question';
import { QuestionEditingOptions } from '@examdojo/models/question-editor';
import { BehaviorSubject, of } from 'rxjs';
import { TopLevelFormGroup } from '../question-item-editor.model';
import { QuestionItemsFormService } from '../question-items-form.service';

@Injectable()
export class QuestionItemsPreviewFormService extends QuestionItemsFormService {
  readonly form = new FormArray<TopLevelFormGroup>([]);

  private readonly questionItems$$ = new BehaviorSubject<QuestionItemV2[]>([]);
  readonly questionItems$ = this.questionItems$$.asObservable();

  readonly editingOptions$ = new BehaviorSubject<QuestionEditingOptions | null>(null);

  override readonly generateSolutionQuestionId$ = of(null);

  initializeForm(questionItems: QuestionItemV2[]) {
    this.questionItems$$.next(questionItems);
  }
}
